import {
  ApplicationConfig,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';

import { provideClientHydration } from '@angular/platform-browser';
import { providePrimeNG } from 'primeng/config';

import Aura from '@primeuix/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { definePreset } from '@primeuix/themes';

import { appRoutes } from './app.routes';
import { authInterceptor } from '../auth/interceptors/auth.interceptor';
import { KeycloakService } from '../auth/services/keycloak.service';
import { initializeKeycloak } from '../auth/keycloak-init.factory';

// Deckt sich mit dem KmtTheme-Preset im kmt-frontend (Mitarbeiter-Portal) —
// einheitliches Erscheinungsbild über beide Angular-Apps hinweg.
const KmtTheme = definePreset(Aura, {
  components: {
    inputtext: {
      root: {
        disabledBackground: '#f3f4f699',
        disabledColor: '#9399a1',
      },
    },
    card: {
      body: {
        padding: '40px',
      },
    },
    tabs: {
      tab: {},
      tabpanel: {
        padding: '0px',
      },
    },
    button: {
      colorScheme: {
        light: {
          outlined: {
            primary: {
              borderColor: '{primary.500}',
              color: '{primary.500}',
              hoverBackground: '{primary.50}',
              activeBackground: '{primary.100}',
            },
          },
        },
      },
    },
  },
  semantic: {
    primary: {
      50: 'rgba(66, 86, 187, 0.05)',
      100: 'rgba(66, 86, 187, 0.2)',
      200: 'rgba(66, 86, 187, 0.4)',
      300: 'rgba(66, 86, 187, 0.6)',
      400: 'rgba(66, 86, 187, 0.8)',
      500: 'rgba(66, 86, 187, 1)', // Haupt-Farbe
      600: 'rgba(53, 69, 150, 1)', // Etwas dunkler für Hover
      700: 'rgba(40, 52, 113, 1)', // Noch dunkler für Active
      800: 'rgba(27, 35, 76, 1)',
      900: 'rgba(13, 18, 38, 1)',
      950: 'rgba(7, 9, 19, 1)',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    providePrimeNG({
      theme: {
        preset: KmtTheme,
        options: {
          darkModeSelector: false,
        },
      },
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
    KeycloakService,
    provideAppInitializer(initializeKeycloak),

    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    provideClientHydration(),
    // { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
    // {
    //   provide: RouteReuseStrategy,
    //   useClass: KmtRouteReuseStrategy,
    // },
    {
      provide: MessageService,
      useClass: MessageService,
    },
    {
      provide: ConfirmationService,
      useClass: ConfirmationService,
    },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    // { provide: 'API_URI', useValue: environment.apiUri },
  ],
};
